export default "__VITE_ASSET__41b1032d__"